import React from 'react';
import { Tooltip } from '@utex/ui-kit';
import { useTranslation } from 'react-i18next';
import { NavItemSecond } from './styles';
export function TooltipHowItWorks(props) {
    var trigger = props.trigger, onIPOClick = props.onIPOClick, onPreIPOClick = props.onPreIPOClick;
    var t = useTranslation('header').t;
    return (React.createElement(Tooltip, { on: "click", padding: [10, 0, 10], width: 200, trigger: trigger, isArrow: false, position: "bottom-start", offset: 0, offsetSkidding: -20 },
        React.createElement("div", null,
            React.createElement(NavItemSecond, { isDisabled: true }, t('About UT Platform')),
            React.createElement(NavItemSecond, { href: "/how-it-works/ipo/ipo-investments", onClick: function (e) {
                    e.preventDefault();
                    onIPOClick();
                } }, t('IPO')),
            React.createElement(NavItemSecond, { href: "/how-it-works/pre-ipo", onClick: function (e) {
                    e.preventDefault();
                    onPreIPOClick();
                } }, t('Pre-IPO')),
            React.createElement(NavItemSecond, { isDisabled: true }, t('OTC')),
            React.createElement(NavItemSecond, { isDisabled: true }, t('Stocks and ETF')))));
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/Navigation/components/TooltipHowItWorks/index.js
// module id = 1359
// module chunks = 118